import { useMutation } from '@gogame/query';

import { updateActivity } from 'scenes/PlayersActivities/LastActivity/source/lastActivity';

import { update } from './queryKeyFactory';

export const useUpdateActivity = () => {
  const updateMutation = useMutation(update(), updateActivity, {
    successMessage: () => 'Activity Updated',
  });
  return [updateMutation.mutateAsync, updateMutation];
};
